export const SINGLE_PLAYGROUND_VIEW_AI = '/ai_imagetotext/playground'
export const SINGLE_PLAYGROUND_VIEW_VIDEO_AI = '/ai_videototext/playground'
export const BULK_TESTS_VIEW_AI = '/ai_imagetotext/bulktests'
export const REFERENCE_LINK = 'https://targetonline.sharepoint.com/sites/AssetHub/SitePages/AI-Tool.aspx'
